import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="inherit"
      height="inherit"
      shapeRendering="crispEdges"
      version="1.1"
      viewBox="0 0 59 60"
    >
      <g transform="translate(1.72 -237)">
        <path
          style={{
            isolation: "auto",
            mixBlendMode: "normal",
            solidColor: "#000000",
            solidOpacity: "1",
            marker: "none",
          }}
          fill="#535353"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          strokeDasharray="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          strokeWidth="0.378"
          d="M32.28 249h9v9h-9zm-18 0h15v12h12v24h-27zm6 6h3v6h-3zm0 21v3h3v-6h10v6h3v-3zm-9 12h33v-36h-6v-6h-27z"
          clipRule="nonzero"
          color="#000"
          colorInterpolation="sRGB"
          colorInterpolationFilters="linearRGB"
          colorRendering="auto"
          display="inline"
          enableBackground="accumulate"
          imageRendering="auto"
          opacity="1"
          overflow="visible"
          paintOrder="fill markers stroke"
          shapeRendering="auto"
          textRendering="auto"
          vectorEffect="none"
          visibility="visible"
        ></path>
      </g>
    </svg>
  );
}

export default Icon;